import { useEffect } from "react";
import { Layout } from "antd";

import { name } from "../../providers/companyInfo";

export default function Public(props) {
	const { children, title, pageId } = props;

	useEffect(() => {
		if (title) {
			document.title = title + " | " + name;
		}

		return () => {};
	}, [title]);

	// useEffect(() => {
	// 	const checkForUpdates = async () => {
	// 		const fetchVersion = await fetch("/meta.json?cache=" + Date.now()); // bust cache
	// 		const { version } = await fetchVersion.json();

	// 		console.log("version: ", version);

	// 		const storedVersion = localStorage.getItem("appVersion");

	// 		if (version !== storedVersion) {
	// 			console.log("New version found. Clearing cache...");

	// 			localStorage.setItem("appVersion", version);

	// 			if ("caches" in window) {
	// 				const cacheNames = await caches.keys();
	// 				await Promise.all(
	// 					cacheNames.map(async (name) => {
	// 						try {
	// 							await caches.delete(name);
	// 							console.log("Cache deleted:", name);
	// 						} catch (e) {
	// 							console.warn("Failed to delete cache:", name, e);
	// 						}
	// 					})
	// 				);
	// 			}
	// 			window.location.reload(true);
	// 		}
	// 	};

	// 	checkForUpdates();

	// 	// window.location.href = "https://joyalife.com.au/maintenance-page";

	// 	const interval = setInterval(checkForUpdates, 60000); // check every 1 min
	// 	return () => clearInterval(interval);
	// }, []);

	return (
		<Layout className="public-layout" id={pageId ?? ""}>
			{children}
		</Layout>
	);
}
